import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=830c23f6&"
import script from "./BaseButton.vue?vue&type=script&lang=js&"
export * from "./BaseButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseButton.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseCopy: require('/opt/build/repo/storefront/components/atoms/Text/BaseCopy.vue').default,SgLink: require('/opt/build/repo/storefront/components/legacy/global/sg-link.vue').default,BaseLink: require('/opt/build/repo/storefront/components/atoms/Link/BaseLink.vue').default})
